import { compact, uniq } from 'lodash';

import { SuggestionForSearchAndEvidence } from '@/modules/aiSuggestions/aiSuggestions.contracts';
import { getSuggestionEvidenceDocumentIds } from '@/modules/aiSuggestions/evidence';

export function getAIOnboardingSuggestionDrawerDocumentIds(
  suggestion: SuggestionForSearchAndEvidence | null | undefined
): string[] {
  return uniq(
    compact([
      ...getSuggestionEvidenceDocumentIds(suggestion?.evidence),
      suggestion?.file?.document?.id,
      ...(suggestion?.kgNode?.mergedFrom?.map((n) => n.file?.document?.id) ??
        []),
    ])
  );
}
